import React from 'react';
import { Button } from '../Button';
import { TextInput } from '../TextInput';
import { useTranslate } from '../util';
import { StyledCopyLink, StyledCopyLinkInput } from './CopyLink.styled';
var currentId = 0;
function getId() {
  var id = "copy-link-".concat(currentId);
  currentId += 1;
  return id;
}

/**
 * Composes a text input and button, where clicking the button copies the input
 * value to the clipboard.
 */
export function CopyLink(props) {
  var id = React.useRef(getId());
  var t = useTranslate();
  var onCopyClick = props.onCopyClick,
    value = props.value,
    _props$copyText = props.copyText,
    copyText = _props$copyText === void 0 ? t('citrix-ui:copy_link') : _props$copyText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? true : _props$readOnly;
  return /*#__PURE__*/React.createElement(StyledCopyLink, null, /*#__PURE__*/React.createElement(StyledCopyLinkInput, null, /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled || isActive,
    id: id.current,
    readOnly: readOnly,
    value: value
  })), /*#__PURE__*/React.createElement(Button.ClipboardPrimary, {
    active: isActive,
    disabled: disabled || isActive,
    onClick: onCopyClick,
    targetId: id.current
  }, copyText));
}